import C7ClubmemCancel from './modules/c7-clubmem-cancel';
import C7ClubSignupCookie from './modules/c7-clubsignup-cookie';

C7ClubSignupCookie.init();
C7ClubmemCancel();